import React from 'react';
import { Package } from 'lucide-react';
import { productList, ProductList, StatusTag, EmptyState, CollapsibleCard } from '../../../common';

function Products({ store }) {
    const storeProducts = productList?.filter((p) => store?.storeType?.products?.includes(p?.value)) || [];

    return (
        <CollapsibleCard
            title="Productos del Tipo de Piso"
            icon={<Package />}
            iconTone="brand"
            badges={<StatusTag tone="neutral">{storeProducts.length} productos</StatusTag>}>
            {storeProducts.length > 0 ? (
                <div className="w-full flex flex-row flex-wrap gap-4">
                    <ProductList products={storeProducts} />
                </div>
            ) : (
                <EmptyState icon={<Package />} title="Sin productos" description="No hay productos configurados para este tipo de piso" />
            )}
        </CollapsibleCard>
    );
}

export default Products;
